var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timeline"},[_c('div',{staticClass:"timeline-base"},_vm._l((_vm.times),function(time){return _c('div',{key:time.time,staticClass:"time"},[_c('span',{style:('color:' + _vm.fontColor)},[_vm._v(_vm._s(time))])])})),_vm._v(" "),_c('div',{staticClass:"hide-area",style:({backgroundColor: _vm.bodyColor})})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e1b2daf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/TimeLine.vue
// module id = null
// module chunks = 